export * from '@opentelemetry/api';
import { ZoneContextManager } from '@opentelemetry/context-zone';
export { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
export { W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
export { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
export { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
export { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
export { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { Resource } from '@opentelemetry/resources';
export { Resource } from '@opentelemetry/resources';
import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
export { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';

let provider = null;
async function initialize(serviceName, signalFxUrl, accessToken, session_id, serviceVersion = '1.0.0') {
    // If a provider already exists, shut it down before re-initializing
    await stopTelemetryService();
    provider = new WebTracerProvider({
        resource: new Resource({
            'service.name': serviceName,
            'service.version': serviceVersion,
        }),
    });
    const exporter = new OTLPTraceExporter({
        url: signalFxUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    const spanProcessor = new BatchSpanProcessor(exporter);
    spanProcessor.onStart = (span, parentContext) => {
        span.setAttribute('sessionId', session_id);
    };
    provider.addSpanProcessor(spanProcessor);
    provider.register({
        contextManager: new ZoneContextManager(),
        propagator: new W3CTraceContextPropagator(),
    });
    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: [/./],
            }),
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: [/./],
            }),
            new UserInteractionInstrumentation(),
        ],
    });
}
async function stopTelemetryService() {
    if (provider) {
        try {
            await provider.shutdown();
        }
        catch (err) {
            console.warn('Previous provider shutdown failed — likely due to expired token', err);
        }
        provider = null;
    }
}

/*
 * Public API Surface of open-telemetry
 */

/**
 * Generated bundle index. Do not edit.
 */

export { initialize };
